var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyChooseBgimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 544,
    viewBox: "0 0 457 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.5 0L0 136.147V407.394L228.5 543.542V543.192L457 407.045V136.147L228.5 0ZM23.9999 164L271.628 313.378L228.5 338.448L23.9999 221.456V164.005V164ZM185.372 229.809L228.5 204.739V255.823L185.372 229.809ZM23.9999 248.965L228.5 366.311L295.279 327.661L346.058 358.302L228.505 426.201L23.9999 308.855V248.965ZM228.5 514.985L23.9999 393.814V336.364L228.5 453.71L369.355 372.231L418.739 401.829L228.495 514.996L228.5 514.985ZM433 379.187L228.582 255.878L272.037 229.722L433 322.085V379.193V379.187ZM433 294.227L228.5 176.887L161.727 215.536L110.948 184.896L228.5 116.997V176.887L279.443 146.224L433 234.338V294.227ZM433 206.829L228.5 89.4827L87.6453 170.962L38.2614 141.363L228.5 27.858V89.4882L279.955 58.5203L433.006 149.727V206.834L433 206.829Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseBgimg);
export default __webpack_public_path__ + "static/media/why-choose-bgimg.6d6d56858e2952b7e2e55dd58c6abff8.svg";
export { ForwardRef as ReactComponent };